import React from 'react';
import Accounts from '../assets/Accounts.svg';
import Apps from '../assets/Apps.svg';
import RightArrow from '../assets/Right_arrow.svg';
import text from '.';

const entityImages = {
	accounts: Accounts,
	apps: Apps,
};
const Entity = (props) => {
	const imgSrc = entityImages[props.entityKey];
	const label = `${props.entityKey.toUpperCase()} WISE`;
	return (
		<button
			type="button"
			className="d-flex flex-column align-items-start position-relative mb-4 entity-card-btn"
			onClick={props.onClick}
			aria-label={`Choose ${label}`}
			style={{
				cursor: 'pointer',
				border: '1px solid #ddd',
				borderRadius: '12px',
				padding: '20px',
			}}
		>
			<div className="d-flex flex-row justify-content-between align-items-start w-100 mb-2">
				<img src={imgSrc} alt="" aria-hidden="true" />
			</div>
			<div className="d-flex flex-row justify-content-between align-items-center w-100 mb-2">
				<h2
					className="mb-0 text-start fw-600"
					style={{
						fontSize: props?.customDetails?.fontSize,
						fontFamily: props?.customDetails?.fontFamily,
					}}
				>
					{label}
				</h2>
				<img src={RightArrow} alt="" aria-hidden="true" style={{ marginLeft: 8 }} />
			</div>
			<div className="text-start w-100">
				<p
					className="mb-0"
					style={{
						fontSize: props?.customDetails?.fontSize,
						color: props?.customDetails.textColor,
					}}
				>
					{text.entityText[props.entityKey]}
				</p>
			</div>
		</button>
	);
};

export default Entity;
